/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * Component imports.
 */
import { GameComponent } from './game.component';
import { GameDetailComponent } from './game-detail/game-detail.component';
import { GameListComponent } from './game-list/game-list.component';
import { GameScreenComponent } from './game-screen/game-screen.component';

const gameRoutes: Routes = [
  {
    path: '', component: GameComponent,
    children: [
      {
        path: 'list/:ncpId', component: GameListComponent
      },
      {
        path: 'detail/:id/:ref', component: GameDetailComponent
      },
      {
        path: 'detail/:id', component: GameDetailComponent
      },
      {
        path: 'playGame/:gameId', component: GameScreenComponent
      },
      { path: '', redirectTo: 'list', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(gameRoutes)
  ],
  exports: [RouterModule]
})
export class GameRoutingModule {
}
